import React, { useState, useEffect } from 'react';



const AnimatedLogo = ({logos,duration}) => {
  // const logos = [obj];
  const [currentIndex, setCurrentIndex] = useState(0); 
  const [animate, setAnimate] = useState(false);

  // const animationDuration = Math.min(500, duration / 3);
  const animationDuration =1000;
  useEffect(() => {
    const interval = setInterval(() => {

       const animationDuration = 500;
      setAnimate(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % logos.length);
        setAnimate(false);
      }, 1000); // Duration of the animation
    }, duration); // 2 seconds delay + 0.5 seconds animation

    return () => clearInterval(interval);
  }, [logos.length,duration ]);

  return (
    // <div className="relative w-[15rem] md:w-[14rem] lg:w-[14rem] xl:w-[20rem] h-[8rem]  overflow-hidden">
    <div className="relative max-w-[25rem] h-[8rem]  overflow-hidden  mx-auto">
      {/* Current logo sliding out */}
      <div
        className={`absolute   top-0 left-0 transition-transform   h-full w-full py-6 px-4 lg:px-0 ease-in-out ${
          animate
            ? currentIndex === 0
              ? 'translate-y-full'
              : currentIndex === 1
              ? 'translate-y-full'
              : currentIndex === 2
              ? 'translate-y-full'
              : 'translate-y-full'
            : 'translate-y-0'
        }`}
        key={currentIndex}
        // style={{ transform: animate ? 'translateY(100%)' : 'translateY(0)' }}
        style={{
          transform: animate ? 'translateY(100%)' : 'translateY(0)',
          transitionDuration: `${animationDuration}ms`
        }}
      >
        {logos[currentIndex].siteLink ?(   <a href={logos[currentIndex].siteLink} target="_blank" rel="noopener noreferrer">
        <img src={logos[currentIndex].icon} alt={logos[currentIndex].altAttribute} className="h-full w-full object-contain" />
        </a>):(
        <img src={logos[currentIndex].icon} alt="Logo" className="h-full w-full object-contain" />
        ) }
     
      </div>

      {/* Next logo sliding in */}
      <div
        className={`absolute top-0 left-0 transition-transform   h-full w-full  py-6 px-4 lg:px-0 ease-in-out ${
          animate ? 'translate-y-0' : 'translate-y-[-100%]'
        }`}
        key={`next-${(currentIndex + 1) % logos.length}`}
        // style={{ transform: animate ? 'translateY(0)' : 'translateY(-100%)', marginTop: 'px' }}
          style={{
          transform: animate ? 'translateY(0)' : 'translateY(-100%)',
          transitionDuration: `${animationDuration}ms`
        }}
      >
        {logos[(currentIndex + 1) % logos.length].siteLink ? (
          <a href={logos[(currentIndex + 1) % logos.length].siteLink} target="_blank" rel="noopener noreferrer">
        <img src={logos[(currentIndex + 1) % logos.length].icon} alt={logos[(currentIndex + 1) % logos.length].altAttribute} className="h-full w-full object-contain" />
        </a>
        ):(
        <img src={logos[(currentIndex + 1) % logos.length].icon} alt="Logo" className="h-full w-full object-contain" />

        )

          
        }
      </div>

      {/* Previous logo (for smoother transitions when looping) */}
      <div
        className={`absolute top-0 left-0 transition-transform  h-full w-full  py-6 px-4 lg:px-0 ease-in-out ${
          animate ? 'translate-y-[-200%]' : 'translate-y-[-100%]'
        }`}
        key={`prev-${(currentIndex - 1 + logos.length) % logos.length}`}
        // style={{ transform: animate ? 'translateY(-200%)' : 'translateY(-100%)' }}
          style={{
          transform: animate ? 'translateY(-200%)' : 'translateY(-100%)',
          transitionDuration: `${animationDuration}ms`
        }}
      >
        {
          logos[(currentIndex - 1 + logos.length) % logos.length].siteLink ? (
             <a href={logos[(currentIndex - 1 + logos.length) % logos.length].siteLink} target="_blank" rel="noopener noreferrer">
        <img src={logos[(currentIndex - 1 + logos.length) % logos.length].icon} alt={logos[(currentIndex - 1 + logos.length) % logos.length].altAttribute } className="h-full w-full object-contain" />
         </a>
           ):(
        <img src={logos[(currentIndex - 1 + logos.length) % logos.length].icon} alt="Logo" className="h-full w-full object-contain" />

           )
        }
        
      </div>
    </div>
  );
};

const SwipAnimation = ({logos,duration}) => {
  return (
    <>
    <div className="rounded-xl py-2 w-full px-2 border border-[rgba(255,255,255,0.3)] shadow-[0_8px_30px_0_rgba(31,38,135,0.10)]  ">
      
      <AnimatedLogo  logos={logos} duration={duration}  className='mx-auto '/>
    </div>
    </>
  );
};

export default SwipAnimation; 